<template>
    <div class="full-block">
        <div class="container">
            <div class="signin-box signin-center">
                <form @submit.prevent="onSubmit">
                    <h3 class="text-center">Sign in Now</h3>
                    <div class="form-group" :class="{ invalid : $v.formdata.email.$error }">
                        <input type="email" v-model.trim="formdata.email" @blur="$v.formdata.email.$touch()" class="form-control" placeholder="Email">
                        <div v-if="$v.formdata.email.$error">
                            <p class="error_label" v-if="!$v.formdata.email.required">This field is required.</p>
                            <p class="error_label" v-if="!$v.formdata.email.email">Please enter a valid email.</p>
                        </div>
                    </div>

                    <div class="form-group" :class="{ invalid : $v.formdata.password.$error }">
                        <input type="password" v-model.trim="formdata.password" @blur="$v.formdata.password.$touch()" class="form-control" placeholder="Password">
                        <div v-if="$v.formdata.password.$error">
                            <p class="error_label" v-if="!$v.formdata.password.required">This field is required.</p>
                            <p class="error_label" v-if="!$v.formdata.password.minLength">At least 7 character.</p>
                        </div>
                    </div>
                    <div class="form-group mb-0 mt-3 text-center"><button type="submit" class="btn btn-primary">Sign in</button></div>
                    <p class="error_label" v-if="error"> Something went wrong. </p>
                    <p class="error_label" v-if="authFailed"> Please check the email and password. </p>
                </form>    
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */ 
import { required, email, minLength } from 'vuelidate/lib/validators';

export default {
    data(){
        return {
            error : false,
            formdata:{
                email:'',
                password:''
            }
        }
    },
    computed:{
        authFailed(){
            return this.$store.state.admin.authFailed;
        }
    },
    destroyed(){
        this.$store.commit('admin/authFailed', 'reset')
    },
    validations:{
        formdata:{
            email:{
                required,
                email
            },
            password:{
                required,
                minLength: minLength(7)
            }
        }
    },
    methods:{
        onSubmit(){
            if(!this.$v.$invalid){
                this.$store.dispatch('admin/signIn', this.formdata);
            } else{
                this.error = true;
                setTimeout( () => {
                    this.error = false;
                }, 3000);
            }
            
        }
    }
}
</script>

<style scoped>
    .input_field.invalid input,
    .input_field.invalid  select{
        border: 1px solid red;
    }
</style>